import request from "../web-sh/src/utils/request";
import global from "../config/global";

async function get_referrals(params = {}) {
  return request({
    url: global.endpoint.REFERRALS,
    method: "get",
    params
  });
}

export default {
  get_referrals,
};
